import { lazy } from 'react';
import { format_routes } from '@/utils/tools';

const Invite = lazy(() => import('../pages/invitePro/index'));
const InviteAnnouncement = lazy(() => import('../pages/invitePro/inviteNotice'));
//招标
const InviteIndex = lazy(() => import('../pages/invitePro/inviteManage/invite'));
const InviteTabs = lazy(() => import('../pages/invitePro/inviteManage/inviteTabs'));
const Application = lazy(() => import('../pages/invitePro/inviteNotice/application'));
//资质审核
const AuditEntries = lazy(() => import('../pages/invitePro/auditEntries'));
//竞价结果
const BidResultDetail = lazy(() => import('../pages/invitePro/inviteManage/bidResultDetail'));
//
const InviteEntry = lazy(() => import('../pages/invitePro/inviteNotice/inviteEntry'));

//投标
const InviteBidding = lazy(() => import('../pages/invitePro/inviteBidding/index'));
const InviteBidTabs = lazy(() => import('../pages/invitePro/inviteBidding/inviteBidTabs'));

//投标人管理
const BidderManagement = lazy(() => import('../pages/invitePro/inviteManage/BidderManagement/index'));
const BidderManagementEdit = lazy(() => import('../pages/invitePro/inviteManage/BidderManagement/edit'));

//投标信息
const BidInformation = lazy(() => import('../pages/invitePro/inviteBidding/BidInformation/index'));
export const inviteRouters = [
  {
    path: '/invite/front',
    element: <InviteAnnouncement />,
    key: 'invitenotice',
    selectKey: 'invitenotice',
    label: '招标公告',
    hidden: false,
  },
  {
    path: '/invite/front/application/:pro_no/:pro_status',
    element: <Application />,
    key: 'application',
    selectKey: 'application',
    hidden: true,
  },
  {
    path: '/invite/front/inviteentry/:pro_no',
    element: <InviteEntry />,
    selectKey: 'bidsignup',
    key: 'bidsignup',
    hidden: true,
  },
  {
    path: '/invite',
    element: <Invite />,
    key: 'invite',
    label: '招标管理',
    children: [
      {
        path: '/invite/index',
        element: <InviteIndex />,
        key: 'InviteIndex',
        selectKey: 'InviteIndex',
        label: '我的招标',
        hidden: false,
        parentKey: 'invite',
      },
      {
        path: '/invite/index/entries/:id/:tabs?',
        element: <AuditEntries />,
        key: 'InviteEntries',
        selectKey: 'InviteIndex',
        hidden: true,
        parentKey: 'invite',
      },
      {
        path: '/invite/index/item/:pro_no/:pro_status?/:pro_tabs?',
        element: <InviteTabs />,
        key: 'InviteTabs',
        selectKey: 'InviteIndex',
        hidden: true,
        parentKey: 'invite',
      },
      {
        path: '/invite/index/item/detail/:pro_no/:pro_status/:id',
        element: <BidResultDetail />,
        key: 'BidResultDetail',
        selectKey: 'InviteIndex',
        hidden: true,
        parentKey: 'invite',
      },
      {
        path: '/invite/biddermanagement/index',
        element: <BidderManagement />,
        key: 'BidderManagement',
        selectKey: 'BidderManagement',
        label: '投标人管理',
        hidden: false,
        parentKey: 'invite',
      },
      {
        path: '/invite/biddermanagement/edit/:id',
        element: <BidderManagementEdit />,
        key: 'BidderManagementEdit',
        selectKey: 'BidderManagementEdit',
        hidden: true,
        parentKey: 'invite',
      },
      {
        path: '/invite/biddermanagement/detail/:id',
        element: <BidderManagementEdit />,
        key: 'BidderManagementEdit',
        selectKey: 'BidderManagementEdit',
        hidden: true,
        parentKey: 'invite',
      },
    ]
  },
  {
    path: '/invite',
    element: <Invite />,
    key: 'inviteentry',
    label: '投标管理',
    children: [
      {
        path: '/invite/inviteentry/index',
        element: <InviteBidding />,
        key: 'InviteEntryIndex',
        selectKey: 'InviteEntryIndex',
        label: '我的投标',
        hidden: false,
        parentKey: 'inviteentry',
      },
      {
        path: '/invite/inviteentry/item/:pro_no/:bid_status?/:bid_tabs?',
        element: <InviteBidTabs />,
        key: 'InviteBidTabs',
        selectKey: 'InviteEntryIndex',
        hidden: true,
        parentKey: 'inviteentry',
      },
      {
        path: '/invite/bidinformation/index',
        element: <BidInformation />,
        key: 'BidInformation',
        selectKey: 'BidInformation',
        label: '投标信息',
        hidden: false,
        parentKey: 'inviteentry',
      },
    ]
  }
];

export const format_invite_router_routes = format_routes(inviteRouters);